import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";
import { StateService } from "@services/state.service";
import { TerminologiaService } from "@services/terminologia.service";
import { Mensajes } from "@shared/enums/mensajes.enum";
import { Archivo } from "@models/archivo.model";
import { DangerError, WarningError } from "@shared/errors/custom.error";
import { ExpedienteService } from "@services/expediente.service";
import { ErrorService } from "@services/error.service";
import { base64DataUrlToBlob } from "@shared/utils/base64toBlob.utils";

@Component({
	selector: "app-expedientes-ver-documentos",
	templateUrl: "./expedientes-ver-documentos.component.html",
})
export class ExpedientesVerDocumentosComponent extends BaseFuncionalidadComponent {
	constructor(
		sessionService: SessionService,
		route: ActivatedRoute,
		location: Location,
		router: Router,
		stateService: StateService,
		private terminologiaService: TerminologiaService,
        private expedienteService: ExpedienteService,
        private errorService: ErrorService
	) {
		super(route, sessionService, location, router, stateService);
	}

    documentos: Archivo[] = []; // Guardar documentos del expediente obtenidos desde la DB
    mensajeSinResultados: string; // Mensaje de respuesta de la BD

	get mensajeSinPermisos(): string {
		return this.terminologiaService.obtenerMensajePorID(
			Mensajes.sin_permisos_funcionalidad
		);
	}

	get mensajeSinPermisosAccion(): string {
		return this.terminologiaService.obtenerMensajePorID(
			Mensajes.sin_permisos_accion
		);
	}

    ngOnInit() {
        this.obtenerDocumentos();
    }

    async obtenerDocumentos() {
        this.isLoading = true;
        try {
          if (!this.canReadDocumentsE) throw new DangerError(this.mensajeSinPermisosAccion);
          if (!this.id) throw new WarningError("Expediente no seleccionado");
          this.documentos = await this.expedienteService.obtenerDocumentos(this.id);
          
        } catch (error) {
          if (error instanceof DangerError) this.mensajeSinResultados = error.message;
          this.errorService.handle(error, "Error al obtener las licencias.");
        } finally {
          this.isLoading = false;
        }
    }

    abrirDocumento(base64: string) {
        const blobUrl = base64DataUrlToBlob(base64)
        window.open(blobUrl, '_blank');
    }
}
